import {
  UPLOAD_IMG
} from "../actions/types";

const initialState = {
  pictures: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_IMG:
      return {
        ...state,
        pictures: [action.payload, ...state.pictures]
      };
    default:
      return state;
  }
}